<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";

const { isLoggedIn, logout, user } = useUser();
const accountMenu = ref(null);
const router = useRouter();

const loginModalController = useModal();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
const isAccountMenuOpen = ref(false);

onClickOutside(accountMenu, () => (isAccountMenuOpen.value = false));

async function invokeResetPassword() {
  await router.push(formatLink("/account/recover"));
  loginModalController.close();
}

const goToRegister = () => {
  loginModalController.close();
  router.push(formatLink("/register"));
};
</script>
<template>
  <ClientOnly>
    <a
      v-show="!isLoggedIn"
      class="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center cursor-pointer"
      data-testid="header-sign-in-link"
      @click="loginModalController.open"
    >
      <img src="/assets/images/user.svg" alt="user" />
    </a>
    <SharedModal :controller="loginModalController">
      <AccountLoginForm
        @close="loginModalController.close"
        @success="loginModalController.close"
      >
        <p class="w-full text-start mt-4">
          <NuxtLink class="underline" @click.stop="invokeResetPassword">
            {{ $t("account.changePassword") }}
          </NuxtLink>
        </p>
        <template #action>
          <button
            type="button"
            class="btn-primary text-lg w-full md:w-auto md:text-22px px-8 h-12 rounded-full md:rounded-full mt-8 md:mt-10 md:mx-2"
            data-testid="login-sign-up-link"
            @click="goToRegister()"
          >
            {{ $t("account.signUp") }}
          </button>
        </template>
      </AccountLoginForm>
    </SharedModal>
    <NuxtLink
      v-if="isLoggedIn"
      :to="formatLink('/account')"
      type="button"
      class="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center"
      data-testid="account-menu-hello-button"
    >
      <img src="/assets/images/user.svg" alt="user" />
    </NuxtLink>
  </ClientOnly>
</template>
